import { render, staticRenderFns } from "./AppRefreshAndExport.vue?vue&type=template&id=8772a23a&scoped=true&"
import script from "./AppRefreshAndExport.vue?vue&type=script&lang=ts&"
export * from "./AppRefreshAndExport.vue?vue&type=script&lang=ts&"
import style0 from "./AppRefreshAndExport.vue?vue&type=style&index=0&id=8772a23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772a23a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
